









































import { Component, Vue, Prop } from 'vue-property-decorator'
import type { LibraryCategory, LibrarySubcategory } from '~/domains/library/Library.types'

@Component
export default class LibraryHeader extends Vue {
  @Prop({
    type: Object,
    default: () => ({}),
    required: false
  })
  currentCategory: LibraryCategory

  @Prop({
    type: Object,
    default: () => ({}),
    required: false
  })
  currentSubcategory: LibrarySubcategory

  @Prop({
    type: Array,
    default: () => ([]),
    required: false
  })
  categories: LibraryCategory[]

  @Prop({
    type: Array,
    default: () => ([]),
    required: false
  })
  breadcrumbs: {
    to: string
    text: string
  }[]

  get pageTitle () {
    return this.currentSubcategory?.name || this.currentCategory?.name || 'Полезные статьи'
  }

  categoryLink (categoryChpu) {
    if (this.currentCategory?.chpuName) {
      return `/library/${this.currentCategory.chpuName}/${categoryChpu}`
    }

    return `/library/${categoryChpu}`
  }
}
